<div *ngFor="let questionnaireWorkflowItem of questionnaireWorkflowItems, let i = index">
	<div nz-row [nzGutter]="[16, 6]">
		<!--TODO wiederholbare workflowschritte, wenn wiederholbar und ageschlossen nzSpan soll jeweils 12 betragen-->
		<div *ngIf="!workflowStatus?.status[questionnaireWorkflowItem.id]?.completed" nz-col [nzSpan]="24">
			<nz-card nzTitle="{{ questionnaireWorkflowItem.name }} ({{ workflowStartedString[i] | translate }})">
				<div class="card-body">
					<div *ngTemplateOutlet="workflowStartContinueCard"></div>
				</div>
			</nz-card>
		</div>
		<div *ngIf="workflowStatus?.status[questionnaireWorkflowItem.id]?.completed" nz-col [nzSpan]="24">
			<nz-card nzTitle="{{ questionnaireWorkflowItem.name }} ({{ 'status.finished' | translate }})">
				<div class="card-body">
					<div *ngTemplateOutlet="workflowFinishedCard"></div>
				</div>
			</nz-card>
		</div>
	</div>

	<ng-template #workflowViewModeSelection>
		<nz-radio-group [(ngModel)]="selectedViewMode" nzSize="large" (ngModelChange)="initSplitButtons()" class="round-radio-button-wrapper">
			<label nz-radio-button nzValue="wizard">
				<i-feather class="icon" name="trello"></i-feather>
				{{ 'workflow.distractionfreeWizard' | translate }}
			</label>
			<label nz-radio-button nzValue="compact">
				<i-feather class="icon" [name]="compactViewIcon"></i-feather>
				{{ 'workflow.compactView' | translate }}
			</label>
		</nz-radio-group>
	</ng-template>

	<ng-template #workflowStartContinueCard>
		<div *ngIf="questionnaireWorkflowItem" nz-row [nzGutter]="[16,8]">
			<div nz-col>
				<div *ngTemplateOutlet="workflowViewModeSelection"></div>
			</div>
			<div nz-col nzSpan="11">
				<app-splitbutton [elements]="workflowStartedContinueSplitButton[i]" size="large" [noIcon]="true" [block]="true"></app-splitbutton>
			</div>
		</div>

	</ng-template>

	<ng-template #workflowFinishedCard>
		<div *ngIf="questionnaireWorkflowItem" nz-row [nzGutter]="[16,8]">
			<div nz-col>
				<div *ngTemplateOutlet="workflowViewModeSelection"></div>
			</div>
			<div nz-col nzSpan="11">
				<app-splitbutton [elements]="workflowFinishedSplitButton[i]" size="large" [noIcon]="true" [block]="true"></app-splitbutton>
			</div>
		</div>
	</ng-template>
</div>
